import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../components/PageHero';
import { SectionStage } from '../components/SectionStage';
import { SectionLabel, SectionHeading } from '../components/ui/UI';
const trustFeatures = ['Scope verification', 'Permission transparency', 'Evidence encryption', 'Redaction', 'Audit logs', 'Tenant isolation', 'Runner security', 'Data retention', 'No destructive testing', 'No real data exfiltration', 'No arbitrary shell'];
export function Trust() {
  return <>
      <PageHero eyebrow="Trust Center" title="Built for" titleMuted="safe validation." description="Security review package available for early-access customers." bg="none" data-id="element-1815" />

      <SectionStage fx="constellation" data-id="element-1816">
        <section className="relative w-full py-32 border-t border-white/5" data-id="element-1817">
          <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1818">
            <SectionLabel number="01" label="Security & Privacy" className="mb-8" data-id="element-1819" />
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-1820">
              <div className="lg:col-span-8" data-id="element-1821">
                <SectionHeading size="xl" data-id="element-1822">
                  Safety is part of
                  <br data-id="element-1823" />
                  <span className="text-white/40" data-id="element-1824">the product.</span>
                </SectionHeading>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-0" data-id="element-1825">
              {trustFeatures.map((feature, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: i * 0.04
            }} className="flex items-center gap-6 py-5 border-b border-white/5" data-id="element-1826">
                  <span className="font-mono text-xs text-[#1a8fd4]/60" data-id="element-1827">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="text-base text-white font-medium" data-id="element-1828">
                    {feature}
                  </span>
                </motion.div>)}
            </div>
          </div>
        </section>
      </SectionStage>
    </>;
}